export const PENDING = 1;
export const ACTIVE = 2;
export const CLOSED = 3;
export const COMPLETED = 4;
export const CANCELLED = 7;
export const DELETED = 8;
export const PROCESSING = 9;
export const NO_REGISTRATION_REQUIRED = 10;
